import { html } from 'lit';

type AppPreview = {
  id: string;
  name: string;
  icon: string;
  url: string;
  platform: 'mac' | 'ios_universal' | 'web';
  'tag_line': string;
}

export default function appRecommendations(apps: AppPreview[], onClick: (url: string, name: string) => void) {
  return html`
    <div class="recommendation">
      <p class="recommendation__title">
        Recommended apps
      </p>

      ${apps.map((app) => html`
        <div
          class="recommendation__app"
          @click=${() => onClick(app.url, app.name)}
        >
          <img
            class="${app.platform !== 'mac' ? 'recommendation__rounded-icon' : ''}"
            src=${app.icon}
            width="72"
            height="72"
            alt=""
          />
          <span class="recommendation__text">
            <span class="recommendation__name">${app.name}</span>
            <span class="recommendation__tag-line">${app.tag_line}</span>
          </span>
          <a class="btn btn_outline-primary btn_sm recommendation__button">
            Try free
          </a>
        </div>
      `)}
    </div>`;
}
